export default "__VITE_ASSET__eOFpaTg3__"